import { useState } from 'react'

import { ICoordinates } from '../../types'

type IUseMapBounds = () => {
  mapBounds: [number, number][] | null
  mapBoundsCenter: ICoordinates | null
  onMapBoundsChange: (bounds: [number, number][], newCenter: ICoordinates) => void
}

/**
 * map bounds we can derive from user moving map
 * used to define the rectangle on the map to show listings within
 * */
const useMapBounds: IUseMapBounds = () => {
  const [mapBounds, setMapBounds] = useState<[number, number][] | null>(null)
  const [mapBoundsCenter, setMapBoundsCenter] = useState<ICoordinates | null>(null)

  const onMapBoundsChange = (bounds: [number, number][], newCenter: ICoordinates) => {
    setMapBounds(bounds)
    setMapBoundsCenter(newCenter)
  }

  return {
    mapBounds,
    mapBoundsCenter,
    onMapBoundsChange,
  }
}

export default useMapBounds
